<template lang="pug">
  div
    el-form(
      :model="param"
      :rules="rules"
      inline=true
      label-width="8vw"
      ref='form-criteria'
    )
      el-row.margin-top-10
        el-col(:span="1") &nbsp;
        el-col(:span="14")
          el-form-item(prop="title.value")
            span(slot="label" class="fieldLabel") Title
            el-input(
              v-model="param.title.value"
              size="small"
              @change="updatePts('title')"
              placeholder="Figure title")
        el-col(:span="9")
          el-form-item(prop="title.score")
            span(class="fieldLabel") Pts
            el-input-number(v-model="param.title.score" :step="1" :min="0" size="small")

      el-row.margin-top-5
        el-col(:span="1") &nbsp;
        el-col(:span="14")
          el-form-item(prop="xLabel.value")
            span(slot="label" class="fieldLabel") X Label
            el-input(
              v-model="param.xLabel.value"
              size="small"
              @change="updatePts('xLabel')"
              placeholder="X label")

        el-col(:span="9")
          el-form-item(prop="xLabel.score")
            span(class="fieldLabel") Pts
            el-input-number(v-model="param.xLabel.score" :step="1" :min="0" size="small")

      el-row.margin-top-5
        el-col(:span="1") &nbsp;
        el-col(:span="14")
          el-form-item(prop="yLabel.value")
            span(slot="label" class="fieldLabel") Y Label
            el-input(
              v-model="param.yLabel.value"
              size="small"
              @change="updatePts('yLabel')"
              placeholder="Y label")

        el-col(:span="9")
          el-form-item(prop="yLabel.score")
            span(class="fieldLabel") Pts
            el-input-number(v-model="param.yLabel.score" :step="1" :min="0" size="small")

</template>

<script>
  import graphFormMixin from '@/components/mixins/graphFormMixin'

  export default {
    mixins: [graphFormMixin],

    props: {
      param: {
        type: Object,
        required: true,
      },
    },
    
    data() {
      return {
        rules : {
          title: {
            value: [{ param: 'title', type: 'number', validator: this.validateValue }],
            score: [{ param: 'title', type: 'number', validator: this.validateScore }],
          },
          xLabel: {
            value: [{ param: 'xLabel', type: 'number', validator: this.validateValue }],
            score: [{ param: 'xLabel', type: 'number', validator: this.validateScore }],
          },
          yLabel: {
            value: [{ param: 'yLabel', type: 'number', validator: this.validateValue }],
            score: [{ param: 'yLabel', type: 'number', validator: this.validateScore }],
          },
        },
      }
    },
  }
</script>

<style scoped>
  .el-input {
    min-width: 28vw;
  }
  .fieldLabel {
    margin-right: 1vw;
    font-size: 1em;
    font-weight: 200;
    color: #757575;
  }
</style>

